import React from 'react';
import {FormControl, FormHelperText, FilledInput, OutlinedInput, InputLabel, Input, Select,CircularProgress,MenuItem} from '@material-ui/core';
import {withFormsy} from 'formsy-react';
import _ from '@lodash';

function SelectFormsy(props)
{ 
    const importedProps = _.pick(props, [
        'autoWidth',
        // 'children',
        'classes',
        'disabled',
        'displayEmpty',
        'input',
        'inputProps',
        'MenuProps',
        'multiple',
        'native',
        'onChange',
        'onClose',
        'onOpen',
        'open',
        'renderValue',
        'SelectDisplayProps',
        'value',
        'variant',
        'required'
    ]);

    // An error message is returned only if the component is invalid
    const errorMessage = props.errorMessage;
    const value = props.value;
    const isLoading = props.isLoading || false;
    const children = isLoading ? 
        (<MenuItem value="loading">
            <CircularProgress color="secondary" size={14} />
        </MenuItem>
        )
        :props.children;

    function input()
    {
        switch ( importedProps.variant )
        {
            case "outlined":
                return <OutlinedInput labelWidth={props.label.length * 8} id={props.name}/>;
            case "filled":
                return <FilledInput id={props.name}/>;
            default:
                return <Input id={props.name}/>
        }
    }

    function changeValue(event)
    {
        props.setValue(event.target.value);
        if ( props.onChange )
        {
            props.onChange(event);
        }
    }

    return (
        <FormControl error={Boolean(errorMessage)} className={props.className} variant={importedProps.variant} required={importedProps.required} disabled={importedProps.disabled}>
            {props.label && (
                <InputLabel htmlFor={props.name} style={{fontSize: props.labelSize}}>{props.label}</InputLabel>
            )}
            {/* to do  Do not pass children as props */}
            <Select
                {...importedProps}
                children={children}
                value={isLoading ? 'loading' : value}
                disabled={isLoading}
                onChange={changeValue}
                input={input()}
            />
            {Boolean(errorMessage) && (
                <FormHelperText>{errorMessage}</FormHelperText>
            )}
        </FormControl>
    );
}

export default React.memo(withFormsy(SelectFormsy));
